export default "__VITE_ASSET__a4ca4dea__"